import type { SubscriptionPeriod } from '@vacationtracker/shared/types/billing'

export const SUBSCRIPTION_PERIOD_STORAGE_KEY = 'vtSubscriptionPeriod'

// Long enough for the OAuth round trips and email verification, short enough that an abandoned
// annual signup does not leak into a later signup that should get the monthly default.
export const SUBSCRIPTION_PERIOD_TTL_MS = 6 * 60 * 60 * 1000

const PERIODS: SubscriptionPeriod[] = ['monthly', 'annual']

const isSubscriptionPeriod = (value: unknown): value is SubscriptionPeriod => PERIODS.includes(value as SubscriptionPeriod)

interface IStoredSubscriptionPeriod {
  period: SubscriptionPeriod
  savedAt: number
}

// Stored like vtSubscriptionPlan so ?subscriptionPeriod= survives the OAuth round trips.
// Matched in any case; anything other than monthly or annual is ignored, so signup keeps its monthly default.
export function saveSubscriptionPeriodFromQuery(value: unknown, now = Date.now()): void {
  const period = typeof value === 'string' ? value.toLowerCase() : value
  if (isSubscriptionPeriod(period)) {
    const stored: IStoredSubscriptionPeriod = { period, savedAt: now }
    localStorage.setItem(SUBSCRIPTION_PERIOD_STORAGE_KEY, JSON.stringify(stored))
  }
}

export function getSavedSubscriptionPeriod(now = Date.now()): SubscriptionPeriod | undefined {
  try {
    const stored = JSON.parse(localStorage.getItem(SUBSCRIPTION_PERIOD_STORAGE_KEY) ?? 'null') as Partial<IStoredSubscriptionPeriod> | null
    const isFresh = typeof stored?.savedAt === 'number' && now - stored.savedAt <= SUBSCRIPTION_PERIOD_TTL_MS
    return isFresh && isSubscriptionPeriod(stored?.period) ? stored.period : undefined
  } catch {
    return undefined
  }
}
